<template>
  <div class="markdown" v-html="content"></div>
   <!-- <div class="markdown">
     <vueMarkdown :source="html" :highlight='highlightCode' />
   </div> -->
</template>

<script>
import mdInCode from './mdInCode' // 用于判断是否显示光标
// import vueMarkdown from 'vue-markdown'
import MarkdownIt from 'markdown-it'
import hljs from 'highlight.js'  // 引入highlight.js
import 'highlight.js/styles/github.css'  // 引入高亮主题（必选）

export default {
  name: 'Markdown',
  components: {
    // vueMarkdown,
  },

  data() {
    return {
      hasCursor: false,
    }
  },

  props: {
    // 输入的 markdown 文本
    text: {
      type: String,
      default: '',
    },
    // 是否需要显示光标？比如在消息流结束后是不需要显示光标的
    showCursor: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    // 高亮处理函数：接收代码内容和语言，返回带高亮样式的HTML
    highlightCode(code, lang) {
      if (lang && hljs.getLanguage(lang)) {
        // 如果指定了语言且hljs支持，直接高亮
        return hljs.highlight(code, { language: lang }).value
      } else {
        // 未指定语言时，自动检测并高亮
        return hljs.highlightAuto(code).value
      }
    }
  },
 
  computed: {
    // html() {
    //   let content = this.text
    //   if (!this.showCursor) {
    //     return content
    //   }
    //   const cursor = '<span class="cursor"></span>'
    //   const inCode = mdInCode(content)
    //   if (!inCode) {
    //     content = content + cursor
    //   }
    //   return content
      
    // },
    content() {
      // 初始化 markdown-it 实例，配置高亮规则
      const md = new MarkdownIt({
        highlight: (code, lang) => { // 自定义高亮逻辑
          if (lang && hljs.getLanguage(lang)) {
            // 语言明确且支持，直接高亮
            return `<pre><code class="language-${lang}">${hljs.highlight(code, { language: lang }).value}</code></pre>`
          }
          // 不明确语言时，自动检测
          return `<pre><code>${hljs.highlightAuto(code).value}</code></pre>`
        },
        html: true, // 允许解析 HTML
        breaks: true, // 支持换行
        linkify: true // 自动识别链接
      })

      let content = this.text
      content = content.replace(/\\"/g, '"').replace(/\\\\/g, '\\')
      content = content.replace(/`\s*(https?:\/\/[^`"]+)\s*`/g, '$1')
      content = content.replace(/\\n/g, '\n')
      content = content.replace(/\r\n/g, '<br/>').replace(/\r<br\/>/g, '<br/>').replace(/<br\s*\/?>/gi, '\n')
      
      if(this.showCursor) {
        const cursor = '<span class="cursor"></span>'
        const inCode = mdInCode(this.text)
        if (!inCode) {
          content = content + cursor
        }
      }

      // 解析 Markdown 为 HTML
      return md.render(content)
    }
  },
}

</script>

<style lang="css">
/** 光标样式 **/
.markdown .cursor {
  display: inline-block;
  width: 1px;
  height: 16px;
  animation: blink 1.2s step-end infinite;
  margin-left: 4px;
  vertical-align: sub;
  background: #213547;
}
@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
